import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IDocumentEngineTemplate } from '@core/entities/document-engine'
import { RequestTypes } from '../requestTypes'
import { documentEngineTemplateKeys } from '../documentEngineTemplateKeys'

export const useUpdateDocumentEngineTemplateExpiryStatus = (
  options?: UseMutationOptions<
    IDocumentEngineTemplate,
    RequestErrorType,
    RequestTypes['updateDocumentEngineTemplateExpiryStatus']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...documentEngineTemplateKeys.updateDocumentEngineTemplateExpiryStatus,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({
        queryKey: documentEngineTemplateKeys.byTemplateId({
          organisationId: variables.organisationId,
          templateId: variables.templateId,
        }).queryKey,
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}
